import React from 'react'

import AppListHeader from './AppListHeader'
import AppListContainer from './AppListContainer'

import AppTypeHeader from './AppTypeHeader'
import AppTypeContainer from './AppTypeContainer'

import {
    AppContainerDiv
} from '../../Styles/Components/AppContainerStyles'

import { useSelector } from "react-redux"

function AppContainer(props){

    const hubPage = useSelector(state => state.hub.hubPage)

    return (
        <AppContainerDiv id="app-container-section">
            {hubPage !== '' ? 
                <>
                    <AppListHeader />
                    <AppListContainer />
                </> :
                <>
                    <AppTypeHeader />
                    <AppTypeContainer />
                </>
            }
        </AppContainerDiv>
    )

}

export default AppContainer